import { clsx } from "clsx";

export default function IconFloorPlan({ className }: { className?: string }) {
  return (
    <svg
      className={clsx("", className)}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4V28H28V4H21V6H26V17H24V19H26V26H17V19H19V17H13V19H15V26H6V19H8V17H6V6H12.6875L18.4375 9.84375L19.5625 8.15625L13.5625 4.15625L13.3125 4H4Z"
        fill="currentColor"
      />
      <path
        d="M4 4V28H28V4H21V6H26V17H24V19H26V26H17V19H19V17H13V19H15V26H6V19H8V17H6V6H12.6875L18.4375 9.84375L19.5625 8.15625L13.5625 4.15625L13.3125 4H4Z"
        fill="currentColor"
        fillOpacity="0.2"
      />
      <path
        d="M4 4V28H28V4H21V6H26V17H24V19H26V26H17V19H19V17H13V19H15V26H6V19H8V17H6V6H12.6875L18.4375 9.84375L19.5625 8.15625L13.5625 4.15625L13.3125 4H4Z"
        fill="currentColor"
        fillOpacity="0.2"
      />
      <path
        d="M4 4V28H28V4H21V6H26V17H24V19H26V26H17V19H19V17H13V19H15V26H6V19H8V17H6V6H12.6875L18.4375 9.84375L19.5625 8.15625L13.5625 4.15625L13.3125 4H4Z"
        fill="currentColor"
        fillOpacity="0.2"
      />
      <path
        d="M4 4V28H28V4H21V6H26V17H24V19H26V26H17V19H19V17H13V19H15V26H6V19H8V17H6V6H12.6875L18.4375 9.84375L19.5625 8.15625L13.5625 4.15625L13.3125 4H4Z"
        fill="currentColor"
        fillOpacity="0.2"
      />
      <path
        d="M4 4V28H28V4H21V6H26V17H24V19H26V26H17V19H19V17H13V19H15V26H6V19H8V17H6V6H12.6875L18.4375 9.84375L19.5625 8.15625L13.5625 4.15625L13.3125 4H4Z"
        fill="currentColor"
        fillOpacity="0.2"
      />
      <path
        d="M4 4V28H28V4H21V6H26V17H24V19H26V26H17V19H19V17H13V19H15V26H6V19H8V17H6V6H12.6875L18.4375 9.84375L19.5625 8.15625L13.5625 4.15625L13.3125 4H4Z"
        fill="currentColor"
        fillOpacity="0.2"
      />
    </svg>
  );
}
